export const routes = {
  // Medical
  medical: '/',
  medicalHome: '/home',
  medicalReceipt: '/receipt',
  medicalDeparture: '/departure',
  medicalRefundInfo: '/refund-info',
  medicalCustomerRefund: '/refund',
  medicalRefundResult: '/refund-result',
  medicalRefundProcedure: '/refund-procedure',
  medicalForceTypeProcedure: '/force-type-procedure',
  medicalCashPickupIntro: '/cash-pickup-intro',
  medicalDepartureCheck: '/departure-check',
  medicalFaq: '/faq',
  medicalFaqEmail: '/faq-email',
  medicalLeaflet: '/refund-info-leaflet',
  medicalKorDeparture: '/kor-departure',
  medicalKorDepartureLocation: '/kor-departure-location',
  uploadKorFile: '/upload',
  medicalUploadFile: '/upload-file',
  uploadKorFileGuide: '/upload-guide',
  medicalDepartureWifi: '/departure-wifi',
  medicalUploadTicket: '/upload-ticket',
  medicalAirport: '/airport',
  medicalSelectAirport: '/select-airport',
  medicalAirportNonRefundable: '/airport-non-refundable',
  medicalAirportGuide: '/airport-guide',
  medicalAirportLocation: '/airport-location',
  medicalAirportReceipt: '/airport-receipt',
  medicalAirportFaq: '/airport-faq',
  inquiryFaq: '/inquiry/faq',
  inquiryPassport: '/inquiry/passport',
  inquiryEmail: '/inquiry/email',
  inquiryQna: '/inquiry/qna',
};
